import React from 'react'
import SignIn from '../SignIn/SignIn'

const Sign = () => {
    return (
        <>
           <SignIn/> 
        </>
    )
}

export default Sign
